export const isAuthenticated = () => !!localStorage.getItem('authToken')

export const getToken = () => localStorage.getItem('authToken')

export const logout = () => {
  localStorage.removeItem('authToken')
  // Additional cleanup (e.g., clear user session data)
}
